import { useFetch } from "../../hooks/useFetch";

export const FetchRolesWithPermissions = async (query) => {
  try {
    return await useFetch(
      `${process.env.REACT_APP_API_URL}/roles/modules`,
      query
    );
  } catch (err) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
